document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded',()=>{
  const b=document.querySelector('[data-mobile-toggle]');
  const n=document.querySelector('[data-mobile-nav]');
  if(b&&n)b.addEventListener('click',()=>{const open=n.classList.toggle('is-open');b.setAttribute('aria-expanded',String(open));});
  document.querySelectorAll('[data-variant-select]').forEach(s=>s.addEventListener('change',()=>{
    const o=s.options[s.selectedIndex];
    const input=s.closest('form').querySelector('[name="id"]');
    if(input)input.value=o.dataset.id;
    const p=document.querySelector('[data-product-price]');
    if(p&&o.dataset.price)p.textContent=o.dataset.price;
    s.closest('form').querySelectorAll('[type="submit"]').forEach(btn=>{btn.disabled=o.dataset.available!=='true';});
    const add=s.closest('form').querySelector('button[type="submit"]:not([name="checkout"])');
    if(add)add.textContent=o.dataset.available==='true'?'Add to cart':'Sold out';
  }));
});
